var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';
import { borderRadius, zIndex, color, triangle, media, Theme } from '../../styles';
import useOnClickOutside from '../hooks';
var opposites = {
    top: 'bottom',
    bottom: 'top',
    right: 'left',
    left: 'right',
    center: 'center'
};
var FlyoutContent = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  cursor: pointer;\n  display: inline-block;\n  background-color: ", ";\n  min-height: 19rem;\n  max-height: 27rem;\n  overflow: auto;\n  overflow-x: hidden;\n"], ["\n  ", ";\n  cursor: pointer;\n  display: inline-block;\n  background-color: ", ";\n  min-height: 19rem;\n  max-height: 27rem;\n  overflow: auto;\n  overflow-x: hidden;\n"])), borderRadius(), color('white'));
function getPlacementCss(placement, width, flyoutType, shift, distance) {
    if (distance === void 0) { distance = flyoutType === 'dropdown' ? '0.5rem' : '1rem'; }
    var opposite = opposites[placement];
    if (!shift) {
        switch (placement) {
            case 'top':
            case 'bottom':
                return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", ": calc(100% + ", ");\n          margin: 0 calc(-", " / 2);\n        "], ["\n          ", ": calc(100% + ", ");\n          margin: 0 calc(-", " / 2);\n        "])), opposite, distance, width);
            case 'right':
            case 'left':
                return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          ", ": calc(100% + ", ");\n          transform: translateY(-50%);\n          top: 50%;\n        "], ["\n          ", ": calc(100% + ", ");\n          transform: translateY(-50%);\n          top: 50%;\n        "])), opposite, distance);
        }
    }
    else {
        switch (placement) {
            case 'top':
            case 'bottom':
                return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          ", ": calc(100% + ", ");\n          left: ", ";\n        "], ["\n          ", ": calc(100% + ", ");\n          left: ", ";\n        "])), opposite, distance, shift || 0);
            case 'right':
            case 'left':
                return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          ", ": calc(100% + ", ");\n          top: ", ";\n        "], ["\n          ", ": calc(100% + ", ");\n          top: ", ";\n        "])), opposite, distance, shift || '0');
            default:
                return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          left: ", ";\n          top: ", ";\n        "], ["\n          left: ", ";\n          top: ", ";\n        "])), distance, shift || '0');
        }
    }
}
var FlyoutWrapper = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  position: absolute;\n  z-index: ", ";\n  background: ", ";\n  ", ";\n  max-height: ", ";\n  width: ", ";\n  max-width: 100vw;\n  box-shadow: ", ";\n  background-color: ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ", ";\n  position: absolute;\n  z-index: ", ";\n  background: ", ";\n  ", ";\n  max-height: ", ";\n  width: ", ";\n  max-width: 100vw;\n  box-shadow: ", ";\n  background-color: ", ";\n  ", ";\n  ", ";\n  ", "\n"])), borderRadius(), zIndex('flyout'), color('white'), function (props) {
    return getPlacementCss(props.placement, props.width, props.type, props.shift, props.distance);
}, function (props) { return props.maxHeight || 'none'; }, function (props) { return props.width; }, function (props) {
    return props.type !== 'dropdown'
        ? '0 0 40px -14px rgba(0, 0, 0, 0.39)'
        : '0 3px 14px 0 rgba(0, 0, 0, 0.17)';
}, function (props) { return color(props.backgroundColor || 'white')(props); }, function (props) {
    return props.type !== 'dropdown'
        ? triangle(__assign(__assign({}, props), { trianglePosition: props.trianglePosition || 'calc(50% - 8px)', borderColor: color('lightGrey')(props), backgroundColor: color(props.backgroundColor || 'white')(props), size: 8, borderWidth: 1 }))
        : null;
}, media.xxsmall(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), function (props) { return props.xxSmallStyles; }), media.medium(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), function (props) { return props.mediumStyles; }));
var Flyout = function (props) {
    var flyoutRef = React.useRef();
    var _a = React.useState(false), mounted = _a[0], setMounted = _a[1];
    useOnClickOutside(flyoutRef, props.close || (function () { }));
    React.useEffect(function () {
        flyoutRef.current = document.querySelector('#flyout-root');
        setMounted(true);
    }, []);
    return mounted ? (_jsxs(Manager, { children: [_jsx(Reference, { children: function (_a) {
                    var ref = _a.ref;
                    return _jsx("span", __assign({ ref: ref }, { children: props.reference }));
                } }), ReactDOM.createPortal(_jsx(Popper, __assign({ placement: props.placement }, { children: function (_a) {
                    var ref = _a.ref, placement = _a.placement, style = _a.style, hasPopperEscaped = _a.hasPopperEscaped;
                    return !hasPopperEscaped &&
                        props.visible && (_jsx("div", __assign({ ref: ref, "data-placement": placement, style: __assign(__assign({}, style), { zIndex: Theme.z.popperFlyout }) }, { children: _jsx(FlyoutWrapper, __assign({ placement: props.placement || 'bottom', shift: props.shift, maxHeight: props.maxHeight, width: props.width, trianglePosition: props.trianglePosition, backgroundColor: props.backgroundColor, style: props.style, xxSmallStyles: props.xxSmallStyles, mediumStyles: props.mediumStyles, className: props.className, type: props.type, distance: props.distance }, { children: props.children })) })));
                } })), flyoutRef.current)] })) : null;
};
export default Flyout;
export { FlyoutContent };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map